import * as React from 'react'
import { cn } from '../../lib/cn'
import { Avatar, type AvatarProps } from '../atoms/Avatar'
import { StatusDot, type StatusDotProps } from '../atoms/StatusDot'

/**
 * IdentityBadge — user cell for tables and rows.
 * Avatar + Name/email + optional StatusDot. Code-composed (no Pencil direct source).
 */
export interface IdentityBadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  name: React.ReactNode
  email?: React.ReactNode
  initials: string
  avatarSrc?: string
  status?: StatusDotProps['status']
  avatarSize?: AvatarProps['size']
}

export const IdentityBadge = React.forwardRef<HTMLDivElement, IdentityBadgeProps>(
  ({ className, name, email, initials, avatarSrc, status, avatarSize = 'md', ...props }, ref) => (
    <div ref={ref} className={cn('flex items-center gap-3 min-w-0', className)} {...props}>
      <div className="relative">
        <Avatar size={avatarSize} initials={initials} src={avatarSrc} alt="" />
        {status && (
          <StatusDot
            status={status}
            size="sm"
            className="absolute bottom-0 right-0 ring-2 ring-card"
            aria-hidden
          />
        )}
      </div>
      <div className="flex flex-col min-w-0">
        <span className="text-body-sm font-medium text-ia-text truncate">{name}</span>
        {email && <span className="text-caption text-ia-text-tertiary truncate">{email}</span>}
      </div>
    </div>
  ),
)
IdentityBadge.displayName = 'IdentityBadge'
